// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC3cBm5cQNwP8bwacoQfkzC7ONDIlrtuSQ",
  authDomain: "calculator-medie-umfcd.firebaseapp.com",
  projectId: "calculator-medie-umfcd",
  storageBucket: "calculator-medie-umfcd.firebasestorage.app",
  messagingSenderId: "602599576248",
  appId: "1:602599576248:web:b2649d395059a11f889a4d",
  measurementId: "G-BD6TGG71G0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);

// Add authentication state change listener with proper error handling
export const onAuthStateChanged = (callback) => {
  return auth.onAuthStateChanged((user) => {
    try {
      if (user && user.emailVerified) {
        // User is signed in and email is verified
        callback(user);
      } else if (user && !user.emailVerified) {
        // User is signed in but email not verified
        console.warn('User email not verified');
        callback(null);
      } else {
        // User is signed out
        callback(null);
      }
    } catch (error) {
      console.error('Auth state change error:', error);
      callback(null);
    }
  });
};

// Enhanced error handling for Firestore operations
export const handleFirestoreError = (error) => {
  console.error('Firestore error:', error);
  
  switch (error.code) {
    case 'permission-denied':
      throw new Error('Nu ai permisiunea să accesezi aceste date.');
    case 'not-found':
      throw new Error('Datele cerute nu au fost găsite.');
    case 'already-exists':
      throw new Error('Datele există deja.');
    case 'resource-exhausted':
      throw new Error('Prea multe cereri. Încearcă din nou mai târziu.');
    case 'unauthenticated':
      throw new Error('Trebuie să te autentifici pentru această acțiune.');
    case 'unavailable':
      throw new Error('Serviciul este temporar indisponibil.');
    default:
      throw new Error('A apărut o eroare neașteptată.');
  }
};

export default app;
